import { Route, Routes } from 'react-router-dom';
import EmployeeDetails from '../../views/Dashboard/TopManagement/pages/EmployeeDetails';
import StudentDetails from '../../views/Dashboard/TopManagement/pages/StudentDetails';
import TutorDetails from '../../views/Dashboard/TopManagement/pages/TutorDetails';
import SalesRetentionDetails from '../../views/Dashboard/TopManagement/pages/SalesRetentionDetails';
import RetentionDetails from '../../views/Dashboard/TopManagement/pages/RetentionDetails';
import LeadsDetails from '../../views/Dashboard/TopManagement/pages/LeadsDetails';
import AssessmentDetails from '../../views/Dashboard/TopManagement/pages/AssessmentDetails';
import RevenueExpenseDetails from '../../views/Dashboard/TopManagement/pages/RevenueExpenseDetails';

export default function TopManagementRouter() {
  return (
    <Routes>
      <Route path="emp-details" element={<EmployeeDetails />} />
      <Route path="student-details" element={<StudentDetails />} />
      <Route path="tutor-details" element={<TutorDetails />} />
      <Route path="sales-details" element={<SalesRetentionDetails />} />
      <Route path="retention-details" element={<RetentionDetails />} />
      <Route path="leads-details" element={<LeadsDetails />} />
      <Route path="assessment-details" element={<AssessmentDetails />} />
      <Route path="revenueOrExpense-details" element={<RevenueExpenseDetails />} />
    </Routes>
  );
}
